import IO from "socket.io-client";
import React from "react";

//const apiConfig = "https://pro.qushi.io:3000/";
const apiConfig = "https://wss-chat.qushi.io/";

export const SOCKET_EV_SEEN = "message_seen";
export const SOCKET_EV_SEND_MESSAGE = "send";
export const SOCKET_EV_SENDED_MESSAGE_DETAILS = "sendedMessageDetail";
export const SOCKET_EV_RECEIVE_MESSAGE = "receive";
export const SOCKET_EV_ACKNOWLEDGEMENT = "acknowledge";
export const SOCKET_EV_JOIN = "join";
// const token = JSON.parse(localStorage.getItem("accessToken"))
// const toke = JSON.parse(token)
export const socket = IO(apiConfig, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 10000000,
  // rejectUnauthorized: false,
  transports: ["websocket"],
});
const pathSegments = window.location.pathname.split("/");

// console.log(pathSegments, "pathSegments");

if (socket?.connected && pathSegments[0] !== "chatHistory") {
  socket.addEventListener("close", () => {
    // console.log("WebSocket closed");
    localStorage.removeItem("gid");
    localStorage.removeItem("id");
  });
  socket.close();
  // console.log("WebSocket disconnected");
} else if (pathSegments[0] === "/chatHistory") {
  socket.on("connect", () => {
    // console.log("Connected...");
  });
  socket.on("connect-error", () => {
    // console.log("Connected...");
  });
}

export const SocketContext = React.createContext();

// const CAR_ID = "2044901"
// const SENDER_ID = "300"
// const RECEIVER_ID = "296"
// const message = {
//     "car_id": "2044865",
//     "sent_by": SENDER_ID,
//     "receiver_id": RECEIVER_ID,
//     "chatId": RECEIVER_ID + SENDER_ID,
//     "type": "text",
//     "is_seen": "0",
//     "message": "hello test",
//     "sender_id": SENDER_ID
// }

export function connectSocket() {}
